/**
 * Short attention beep when topic planned time is reached.
 * Plays once per call; cancels any in-flight beep so sounds never stack.
 */

let activeCtx: AudioContext | null = null;
let closeTimer: number | null = null;
let playing = false;

function stopActiveBeep(): void {
  if (closeTimer != null) {
    window.clearTimeout(closeTimer);
    closeTimer = null;
  }
  if (activeCtx) {
    const ctx = activeCtx;
    activeCtx = null;
    try {
      void ctx.close();
    } catch {
      /* ignore */
    }
  }
  playing = false;
}

export function playTopicTimeUpBeep(): void {
  // One beep at a time — ignore overlapping calls (re-renders / Strict Mode).
  if (playing) return;

  try {
    const AC =
      window.AudioContext ||
      (window as unknown as { webkitAudioContext: typeof AudioContext })
        .webkitAudioContext;
    stopActiveBeep();
    const ctx = new AC();
    activeCtx = ctx;
    playing = true;

    const start = () => {
      if (activeCtx !== ctx) return;
      const beep = (at: number, freq: number, dur: number) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = "sine";
        osc.frequency.value = freq;
        gain.gain.setValueAtTime(0.0001, at);
        gain.gain.exponentialRampToValueAtTime(0.28, at + 0.02);
        gain.gain.exponentialRampToValueAtTime(0.0001, at + dur);
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.start(at);
        osc.stop(at + dur + 0.02);
      };
      const t0 = ctx.currentTime;
      beep(t0, 880, 0.18);
      beep(t0 + 0.22, 880, 0.18);
      beep(t0 + 0.44, 660, 0.28);
      // Total pattern ~0.74s — close shortly after and allow a future beep.
      closeTimer = window.setTimeout(() => {
        if (activeCtx === ctx) {
          stopActiveBeep();
        }
      }, 900);
    };

    if (ctx.state === "suspended") {
      void ctx.resume().then(start).catch(() => {
        stopActiveBeep();
      });
    } else {
      start();
    }
  } catch {
    stopActiveBeep();
  }
}

/** Force-stop (e.g. modal dismissed mid-beep). */
export function stopTopicTimeUpBeep(): void {
  stopActiveBeep();
}
